import {useContextElement} from "../../context/Context";
import {Link} from "react-router-dom";
import axios from "axios";
import {loadStripe} from "@stripe/stripe-js";
import React, {useEffect, useState} from "react";
import api from "../../shared/AxiosConfig";
import { toast } from "react-toastify";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

export default function Checkout({onLoaded}) {
    const {cartProducts, totalPrice} = useContextElement();
    const [agreed, setAgreed] = React.useState(false);
    const [showError, setShowError] = React.useState(false);


    useEffect(() => {
        if (cartProducts?.length > 0) {
            onLoaded?.();
        }
    }, [cartProducts]);

    const [firstname, setFirstname] = useState("");
    const [lastname, setLastname] = useState("");
    const [country, setCountry] = useState("");
    const [address, setAddress] = useState("");
    const [apartment, setApartment] = useState("");
    const [city, setCity] = useState("");
    const [postcode, setPostcode] = useState("");
    const [phone, setPhone] = useState("");
    const [orderNote, setOrderNote] = useState("");

    const [subtotal, setSubtotal] = useState(0);
    const [tax, setTax] = useState(0);

    useEffect(() => {
        const calculatedSubtotal = cartProducts.reduce((acc, item) => acc + item.price * item.quantity, 0);
        const calculatedTax = calculatedSubtotal * 0.2; // %20 KDV örnek

        setSubtotal(calculatedSubtotal);
        setTax(calculatedTax);

    }, [cartProducts]);


    const makePayment = async (e) => {
        e.preventDefault();

        if (!agreed) {
            setShowError(true);
            // erişilebilirlik: checkbox'a odaklan
            const el = document.getElementById("check-agree");
            if (el) el.focus();
            return;
        }

        const requiredFields = [
            { value: firstname, id: "firstname", label: "First name" },
            { value: lastname,  id: "lastname",  label: "Last name" },
            { value: address,   id: "address",   label: "Address" },
            { value: city,      id: "city",      label: "City" },
            { value: postcode,  id: "code",      label: "Zipcode/Postal" },
            { value: phone,     id: "phone",     label: "Phone" },
        ];


        const emptyField = requiredFields.find(
            f => !f.value || f.value.trim() === ""
        );

        if (emptyField) {
            toast.error(`Please fill in the "${emptyField.label}" field.`);

            const el = document.getElementById(emptyField.id);
            if (el) {
                el.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "nearest",
                });
                // ❌ focus yok, yoksa iOS klavye+scroll manyaklaşıyor
            }

            return;
        }



        if (!cartProducts?.length) return;

        const shippingAddress = {
            fullName: `${firstname} ${lastname}`,
            phoneNumber: phone,
            addressLabel: "Shipping Address",
            country,
            city,
            postcode,
            addressLine1: address,
            addressLine2: "",
            addressNote: "",
        };

        try {
            const stripe = await stripePromise;

            const response = await api.post("/payment/create-checkout-session",
                {
                    cart: cartProducts,
                    shippingAddress,
                    orderNote
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                    }
                }
            );

            const session = response.data;
            const result = await stripe.redirectToCheckout({sessionId: session.id});

            if (result.error) {
                console.error("Stripe error:", result.error.message);
            }
        } catch (err) {
            console.error("Payment Error", err);
        }
    };

    return (
        <div className="flat-spacing-25 input-page">
            <div className="container">
                <div className="row">
                    <div className="col-xl-8">
                        <form className="tf-checkout-cart-main" onSubmit={makePayment}>
                            <div className="box-ip-checkout">
                                <div className="title text-lg fw-medium">Checkout</div>
                                <div className="grid-2 mb_16">
                                    <div className="tf-field style-2 style-3">
                                        <input
                                            className="tf-field-input tf-input"
                                            id="firstname"
                                            placeholder=" "
                                            type="text"
                                            name="firstname"
                                            value={firstname}
                                            onChange={(e) => setFirstname(e.target.value)}
                                        />

                                        <label className="tf-field-label" htmlFor="firstname">First name</label>
                                    </div>
                                    <div className="tf-field style-2 style-3">
                                        <input
                                            className="tf-field-input tf-input"
                                            id="lastname"
                                            placeholder=" "
                                            type="text"
                                            name="lastname"
                                            value={lastname}
                                            onChange={(e) => setLastname(e.target.value)}
                                        />

                                        <label className="tf-field-label" htmlFor="lastname">Last name</label>
                                    </div>

                                </div>
                                <fieldset className="tf-field style-2 style-3 mb_16">
                                    <input
                                        className="tf-field-input tf-input"
                                        id="country"
                                        type="text"
                                        name="country"
                                        value="United Kingdom"
                                        disabled
                                    />
                                    <label className="tf-field-label" htmlFor="country">Country</label>
                                </fieldset>


                                <fieldset className="tf-field style-2 style-3 mb_16">
                                    <input
                                        className="tf-field-input tf-input"
                                        id="address"
                                        type="text"
                                        name="address"
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                    />

                                    <label className="tf-field-label" htmlFor="address">Address</label>
                                </fieldset>
                                <fieldset className="tf-field style-2 style-3 mb_16">
                                    <input
                                        type="text"
                                        className="tf-field-input tf-input"
                                        name="apartment"
                                        placeholder=""
                                        value={apartment}
                                        onChange={(e) => setApartment(e.target.value)}
                                    />

                                    <label className="tf-field-label" htmlFor="apartment">Apartment, suite, etc
                                        (optional)</label>
                                </fieldset>
                                <div className="grid-3 mb_16">
                                    <div className="tf-select select-square">
                                        <select
                                            name="city"
                                            id="city"
                                            required
                                            value={city}
                                            onChange={(e) => setCity(e.target.value)}
                                        >
                                            <option value="">Select City</option>
                                            <option value="London">London</option>
                                            <option value="Manchester">Manchester</option>
                                            <option value="Birmingham">Birmingham</option>
                                            <option value="Liverpool">Liverpool</option>
                                            <option value="Leeds">Leeds</option>
                                            <option value="Glasgow">Glasgow</option>
                                            <option value="Sheffield">Sheffield</option>
                                            <option value="Bristol">Bristol</option>
                                            <option value="Nottingham">Nottingham</option>
                                            <option value="Leicester">Leicester</option>
                                        </select>
                                    </div>

                                    {/*<fieldset className="tf-field style-2 style-3">*/}
                                    {/*    <input*/}
                                    {/*        className="tf-field-input tf-input"*/}
                                    {/*        id="city"*/}
                                    {/*        type="text"*/}
                                    {/*        name="city"*/}
                                    {/*        placeholder=""*/}
                                    {/*    />*/}
                                    {/*    <label className="tf-field-label" htmlFor="city">*/}
                                    {/*        City*/}
                                    {/*    </label>*/}
                                    {/*</fieldset>*/}

                                    <fieldset className="tf-field style-2 style-3">
                                        <input
                                            className="tf-field-input tf-input"
                                            id="code"
                                            type="text"
                                            name="zipcode"
                                            value={postcode}
                                            onChange={(e) => setPostcode(e.target.value)}
                                        />
                                        <label className="tf-field-label" htmlFor="code">Zipcode/Postal</label>
                                    </fieldset>

                                    <fieldset className="tf-field style-2 style-3 mb_16">
                                        <input
                                            className="tf-field-input tf-input"
                                            id="phone"
                                            type="text"
                                            name="phone"
                                            value={phone}
                                            onChange={(e) => setPhone(e.target.value)}
                                        />
                                        <label className="tf-field-label" htmlFor="phone">Phone</label>
                                    </fieldset>
                                </div>


                                <div className="cart-note">
                                    <label className="text-md fw-medium">Special instructions for seller</label>
                                    <textarea value={orderNote} onChange={(e) => setOrderNote(e.target.value)}/>
                                </div>
                            </div>
                        </form>
                    </div>

                    <div className="col-xl-4">
                        <div className="tf-page-cart-sidebar">
                            <form className="cart-box order-box" onSubmit={makePayment}>
                                <div className="title text-lg fw-medium">In your cart</div>
                                {cartProducts.length ? (
                                    <ul className="list-order-product">
                                        {cartProducts.map((product, i) => (
                                            <li key={i} className="order-item">
                                                <figure className="img-product">
                                                    <img alt="product" src={product.coverImage} width={144}
                                                         height={188}/>
                                                    <span className="quantity">{product.quantity}</span>
                                                </figure>
                                                <div className="content">
                                                    <p className="name text-sm fw-medium">{product.title}</p>
                                                    <span className="variant">{product.size}</span>
                                                    <span
                                                        className="price text-sm fw-medium">£{(product.price * product.quantity).toFixed(2)}</span>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <p>Cart is empty</p>
                                )}


                                <ul className="list-total">
                                    <li className="total-item text-sm d-flex justify-content-between">
                                        <span>Subtotal:</span>
                                        <span className="price-sub fw-medium">£{(subtotal - tax).toFixed(2)} GBP</span>

                                    </li>
                                    <li className="total-item text-sm d-flex justify-content-between">
                                        <span>Tax (%20):</span>
                                        <span className="price-tax fw-medium">£{tax.toFixed(2)} GBP</span>
                                    </li>
                                </ul>
                                <div className="subtotal text-lg fw-medium d-flex justify-content-between">
                                    <span>Total:</span>
                                    <span>£{(totalPrice).toFixed(2)} GBP</span>
                                </div>

                                <div className="check-agree mt-2">
                                    <input
                                        type="checkbox"
                                        className="tf-check"
                                        id="check-agree"
                                        checked={agreed}
                                        onChange={(e) => {
                                            setAgreed(e.target.checked);
                                            if (e.target.checked) setShowError(false);
                                        }}
                                        aria-invalid={showError && !agreed}
                                        aria-describedby="tc-error"
                                    />
                                    {/* ❗boşluğu kaldırdık */}
                                    <label htmlFor="check-agree" className="label text-dark-4">
                                        &nbsp;&nbsp;I agree with{" "}
                                        <Link to="/terms-and-condition"
                                              className="text-dark-4 fw-medium text-underline link">
                                            term and conditions
                                        </Link>
                                    </label>
                                </div>

                                {showError && !agreed && (
                                    <p id="tc-error" className="small text-danger mt-3" aria-live="polite">
                                        Please accept the terms and conditions to continue!
                                    </p>
                                )}

                                <div className="btn-order">
                                    <button
                                        type="submit"
                                        className="tf-btn btn-dark2 animate-btn w-100"
                                        // ❗ artık disabled yok; tıklamada biz engelliyoruz
                                        onClick={(e) => {
                                            if (!agreed) {
                                                e.preventDefault();            // submit'i blokla
                                                setShowError(true);            // hatayı göster
                                                document.getElementById("check-agree")?.focus(); // checkbox'a odakla
                                            }
                                        }}
                                    >
                                        Place order
                                    </button>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
